// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {1060: "236ace29d4fdbb8d",6409: "f2a65bc85e78e0d8",7026: "6ddf6efe3c6069d5",8638: "18920318e6ac757d",}[chunkId] + ".css"
}